export const validateAuthForm = (form , endPoint) => {
    const errors = {};

    if(endPoint === "signup"){
        if (!form.name.trim()) errors.name = "Username is required";
    }
    
    if (!form.email.trim()) errors.email = "Email is required";
    else if (!/^\S+@\S+\.\S+$/.test(form.email)) errors.emailFormat = "Invalid email format";

    if (!form.password.trim()) errors.password = "Password is required";

    if(endPoint === "signup"){
     if (form.password.length < 8) errors.passwordReq = "Password must be at least 8 characters";
    }

    if (endPoint === "signup") {
        if (!form.passwordC.trim()) {
            errors.passwordC = "Confirm password is required";
        } else if (form.password !== form.passwordC) {
            errors.passwordCMatch = "Passwords don't match";
        }
    }

    return errors;
};